import {afterNextRender, AfterViewInit, Component, computed, inject, OnInit, PLATFORM_ID, signal} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {NavbarComponent} from './navbar/navbar.component';
import {bgColorOfRoute, navBarColorOfRoute} from '../../common/colors';
import {filter, map, mergeMap} from 'rxjs';
import {DOCUMENT, isPlatformBrowser, NgIf} from '@angular/common';
import {SeoService} from '../../services/seo.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {blank} from '../../common/strings';
import {SocialTrackService} from '../../services/social-track.service';
import {SessionAgeDeciderService} from '../../services/session-age-decider.service';
import {WINDOW} from '../config/module.di.tokens';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NavbarComponent,
    NgIf
  ],
  providers: [
  ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, AfterViewInit {

  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);
  router = inject(Router)
  route = inject(ActivatedRoute)
  activatedRoute = inject(ActivatedRoute)
  seo = inject(SeoService)
  socialTrackService = inject(SocialTrackService)
  sessionAgeDeciderService = inject(SessionAgeDeciderService)
  window = inject(WINDOW)

  scrolling = signal<boolean>(false)
  routerUrl = toSignal(
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => (e as NavigationEnd).urlAfterRedirects)
    ),
    { initialValue: isPlatformBrowser(this.platformId) ? this.window.location.pathname : this.router.url }
  );

  backgroundColor = computed(() => {
    const url = this.routerUrl() || this.router.url || blank;
    return `bg-${bgColorOfRoute(url)}`;
  });

  navBarColor = computed(() => {
    const url = this.routerUrl() || this.router.url || blank;
    const scrolling = this.scrolling()
    return `bg-${navBarColorOfRoute(url, scrolling)}`;
  });

  constructor() {
    afterNextRender(async () => {
      await this.sessionAgeDeciderService.loadConfig()
      await this.socialTrackService.initTracking()
    })


    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    ).subscribe(data => {
      if (data['seo']) {
        this.seo.updateMetadata(data['seo']);
      }
    });
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe(() => {
          const mainScrollElement = this.document.querySelector(".main-scroll") as HTMLElement;
          mainScrollElement.scrollTop = 0;
          mainScrollElement.scrollLeft = 0;
        });
    }
  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const mainScrollElement = this.document.querySelector(".main-scroll") as HTMLElement;
      mainScrollElement.addEventListener('scroll', () => {
        this.scrolling.set(mainScrollElement.scrollTop > 0)
      });
    }
  }

  scrollToTop() {
    const mainScrollElement = this.document.querySelector(".main-scroll") as HTMLElement;
    mainScrollElement.scrollTo({behavior: 'smooth', top: 0});
  }








}
